import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//

import { imgCut } from '@/utils/';
export default {
  name: 'default-image',
  props: {
    src: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 0
    },
    height: {
      type: Number,
      default: 220
    }
  },
  data: function data() {
    return {
      isImageLoaded: false
    };
  },
  computed: {
    imgUrl: function imgUrl() {
      var src = this.src,
        width = this.width,
        height = this.height;
      if (!src) return '';
      if (width && height) {
        return imgCut(src, width, height);
      }
      return src;
    }
  },
  created: function created() {
    this.imgUrl && this.preLoadImage(this.imgUrl);
  },
  watch: {
    src: function src(val) {
      this.isImageLoaded = false;
      this.preLoadImage(val);
    }
  },
  methods: {
    preLoadImage: function preLoadImage(src) {
      var _this = this;
      if (src) {
        var tempIMG = new Image();
        tempIMG.onload = function () {
          _this.isImageLoaded = true;
        };
        tempIMG.onerror = function () {
          _this.isImageLoaded = false;
        };
        tempIMG.src = src;
      } else {
        this.isImageLoaded = false;
      }
    }
  }
};